import { Typography } from "@mui/material"
import styled from "styled-components"
import useInStock from "../wizard/useInStock"

const DisclaimerContainer = styled.div`
  margin-bottom: 20px;
  p {
    font-size: 18px;
    font-weight: 300;
  }
`

const Disclaimer = () => {
  const inStock = useInStock()

  if (!inStock) return null

  return (
    <DisclaimerContainer>
      <Typography variant="body2" color="textSecondary">
        אנו שמחים להתקדם יחד! כדי שנוכל לשמור לך את ההצעה וההטבות, נדרש תשלום
        מקדמה. לאחר מכן ניצור איתך קשר על מנת להתקדם בעסקה. במידה ולא תושלם
        הרכישה, תוחזר לך המקדמה במלואה{" "}
      </Typography>
    </DisclaimerContainer>
  )
}

export default Disclaimer
